import { notifications } from '@mantine/notifications'
import { IconCheck, IconX } from '@tabler/icons-react'
import { AxiosError } from 'axios'

const errorMessageMap = new Map([
  [
    'Network Error',
    'We’re having trouble connecting to the network. Please check your internet connection and try again.',
  ],
  ['Forbidden', "You don't have permission to perform this action."],
])

export const showNotificationWithError = (error: Error, title: string) => {
  const xIcon = <IconX size={20} />
  let message = error instanceof AxiosError && error.response?.data ? error.response.data.message : error.message

  if (errorMessageMap.has(message)) {
    message = errorMessageMap.get(message)
  }

  notifications.show({
    title: title,
    message: typeof message === 'string' ? message : JSON.stringify(message),
    color: 'red',
    icon: xIcon,
    autoClose: 5000,
  })
}

export const showNotificationWithSuccess = (title: string, message: string) => {
  const checkIcon = <IconCheck size={20} />
  notifications.show({ title: title, message: message, color: 'green', icon: checkIcon, autoClose: 5000 })
}
